import { FC, ReactNode, useMemo } from 'react';
import { useMediaQuerySSR } from 'src/hooks/useStateSSR';
import { useHref } from 'src/hooks/useHref';
import { TargetLocaleBackground } from 'src/containers';
import { ROUTES } from 'src/constants/routes.const';
import theme from 'src/utils/theme';
import * as S from './styles';

type Props = {
  flagUrl: string;
  title: string;
  description: string | ReactNode;
};

export const PhrasebookPageHeader: FC<Props> = ({ flagUrl, title, description }) => {
  const isMobile = useMediaQuerySSR(false, { maxWidth: theme.sz.md });

  const allLearnablesHref = useHref({
    pathname: ROUTES.phrasebook.allLearnables,
  });

  const breadcrumbs = useMemo(
    () => [{ name: title, url: allLearnablesHref }],
    [allLearnablesHref, title],
  );

  return (
    <S.Wrapper>
      <TargetLocaleBackground>
        <S.LanguagePairBreadcrumbs breadcrumbs={breadcrumbs} inverse />
        <S.FlexWrapper>
          {!isMobile && <S.Flag src={flagUrl} alt="" />}
          <div>
            <S.MobileFlexWrapper>
              {isMobile && <S.Flag src={flagUrl} alt="" />}
              <S.Title>{title}</S.Title>
            </S.MobileFlexWrapper>
            <S.Description>{description}</S.Description>
          </div>
        </S.FlexWrapper>
      </TargetLocaleBackground>
    </S.Wrapper>
  );
};

export default PhrasebookPageHeader;
